module.exports = __webpack_public_path__ + "static/media/cognito_settings.6d1730b2.svg";